import { IBaseEntry } from "../../../../base/interfaces/IBaseEntry";
import { IFileStoreItem } from "../../../../documents/interfaces/IFileStoreItem";

export class ImageBrowserElement {
    file:IFileStoreItem;
    elem:IBaseEntry;
    constructor(file:IFileStoreItem, elem:IBaseEntry){
        this.file = file;
        this.elem = elem;
    }
}